module.exports = __webpack_public_path__ + "static/media/russia.0dd3f809.svg";